import { oz } from '@weft/utils';
import { CHANNEL_TYPE } from './channel-type-schema';

export const WebhookChannelSchema = oz.object({
  type: oz.literal(CHANNEL_TYPE.Webhook),
  configuration: oz.object({
    callbackUrl: oz.string(),
  }),
}).openapi('WebhookChannel');

export type WebhookChannel = oz.infer<typeof WebhookChannelSchema>;